import React from "react";
import { IconEye } from "@tabler/icons-react";
import formatDate from "../../../utilities/helper";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

type Shipment = {
  id: string;
  sn: number;
  awb: string;
  reference: string;
  entryDate: string;
  payMode: string;
  platform: string;
  origin: string;
  destination: string;
  orderType: string;
  shippingCompany: string;
  shippingAwb: string;
  city: string;
  status: string;
};

type Props = {
  data: {
    orders: Shipment[];
  };
  onEdit: (shipment: Shipment) => void;
  columnsData: {
    id?: number;
    text?: string;
    value?: string;
    isShow?: boolean;
  }[];
  type?: string;
  orderType?: boolean;
  pending?: boolean;
  currentPage: number;
  limitPage: number;
  isCheckboxEnabled: boolean;
  selectedOrders: Shipment[];
  onSelectOrder: (order: Shipment) => void;
};

const getStatusClass = (status: string) => {
  const normalized = status?.toLowerCase();

  switch (normalized) {
    case "draft":
      return "bg-gray-200 text-gray-800 border border-[#d2d2d2]";
    case "new_order":
      return "bg-blue-100 text-blue-800 border border-blue-800";
    case "processing":
      return "bg-indigo-100 text-indigo-800 border border-indigo-800";
    case "ready_for_pickup":
      return "bg-yellow-100 text-yellow-800 border border-yellow-800";
    case "dispatched":
      return "bg-green-100 text-green-800 border border-green-800";
    case "in_transit":
      return "bg-sky-100 text-sky-800 border border-sky-800";
    case "out_for_delivery":
      return "bg-orange-100 text-orange-800 border border-orange-800";
    case "delivered":
      return "bg-lime-100 text-lime-800 border border-lime-800";
    case "undelivered":
      return "bg-amber-100 text-amber-800 border border-amber-800";
    case "returned":
      return "bg-pink-100 text-pink-800 border border-pink-800";
    case "cancelled":
      return "bg-red-100 text-red-800 border border-red-800";
    case "failed":
      return "bg-rose-100 text-rose-800 border border-rose-800";
    case "lost":
      return "bg-zinc-200 text-zinc-700 border border-zinc-800";
    case "deleted":
      return "bg-red-500 text-white border border-red-800";
    default:
      return "bg-gray-100 text-gray-800 border border-[#d2d2d2]";
  }
};

const formatStatus = (status: string) => {
  return status
    ?.toLowerCase()
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const AllOrderTable: React.FC<Props> = ({
  data,
  orderType,
  pending,
  currentPage,
  limitPage,
  columnsData,
  isCheckboxEnabled,
  selectedOrders,
  onSelectOrder,
  onEdit,
}) => {
  const navigate = useNavigate();

  const profile = useSelector((state: any) => state.auth.profile);
  const isOrder = profile?.clientType === "LM";

  return (
    <div className=" bg-[#F7F6F2] pt-2 rounded-r-3xl rounded-b-3xl">
      <div className=" bg-[#FCFDF8] rounded-tl-none rounded-3xl overflow-hidden overflow-x-auto overflow-y-auto max-h-[90vh] hide-scrollbar ">
        <table className="w-full text-sm whitespace-nowrap ">
          <thead className="border-b border-dashed border-gray-300 sticky top-0 z-20 shadow-sm bg-[#FCFDF8]">
            <tr className="text-left ">
              {
                // columnsData.find((c) => c.value === "checkbox")?.isShow &&
                // isCheckboxEnabled && (
                  <th
                    rowSpan={2}
                    className="px-4 pt-2 font-semibold text-[#131327]/70"
                  >
                    <label className="relative flex items-center cursor-pointer"> 
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          if (e.target.checked) {
                            data.orders.forEach((order) => {
                              if (
                                !selectedOrders.some((o) => o.id === order.id)
                              ) {
                                onSelectOrder(order);
                              }
                            });
                          } else {
                            selectedOrders.forEach((order) => {
                              onSelectOrder(order);
                            });
                          }
                        }}
                        checked={
                          selectedOrders.length === data.orders.length &&
                          data.orders.length > 0
                        }
                        className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                    />
                    <span
                      className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                  top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                    >
                      ✓
                    </span>
                  </label>
                </th>
                // )
              }
              {columnsData.find((c) => c.value === "sn")?.isShow && (
                <th
                  rowSpan={2}
                  className="px-4 pt-2  font-semibold text-[#131327]/70 border-r border-dashed border-gray-300 "
                >
                  #
                </th>
              )}
              {/* {columnsData.find((c) => c.value === "orderType")?.isShow && ( */}
              <th
                rowSpan={2}
                className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
              >
                Tags
              </th>
              {/* )} */}

              {/* {columnsData.find((c) => c.value === "orderDate")?.isShow && ( */}
              <th
                rowSpan={2}
                className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
              >
                Order Date
              </th>
              {/* )} */}
              {columnsData.find((c) => c.value === "platform")?.isShow && (
                <th
                  rowSpan={2}
                  className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
                >
                  Platform
                </th>
              )}
              {/* {columnsData.find((c) => c.value === "awbNumber")?.isShow && ( */}
              <th
                rowSpan={2}
                className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
              >
                AWB No.
              </th>
              {/* )} */}

              {/* {columnsData.find((c) => c.value === "referenceNumber")
                ?.isShow && ( */}
              <th
                rowSpan={2}
                className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
              >
                Reference
              </th>
              {/* )} */}
              {/* {columnsData.find((c) => c.value === "routeCode")?.isShow && ( */}
              <th
                rowSpan={2}
                className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
              >
                Route
              </th>
              <th
              rowSpan={2}
              className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
            >
              Outlet Code
              </th>
              {/* )} */}
              {columnsData.find((c) => c.value === "outletName")?.isShow && (
                <th
                  rowSpan={2}
                  className="px-4 pt-2 font-semibold text-[#131327]/70 border-r border-dashed border-gray-300"
                >
                  Outlet Name
                </th>
              )}
              {columnsData.find((c) => c.value === "shippingDetails")
                ?.isShow && (
                <th
                  colSpan={2}
                  rowSpan={1}
                  className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x  border-dashed border-gray-300 "
                >
                  Shipping Details
                </th>
              )}

              {/* {columnsData.find((c) => c.value === "origin")?.isShow && ( */}
              <th className="px-4 pt-2 font-semibold text-[#131327]/70">
                Origin
              </th>
              {/* )} */}
              {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
              <th
                colSpan={4}
                className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300 "
              >
                Destination
              </th>
              {/* )} */}

              {columnsData.find((c) => c.value === "receiverDetails")
                ?.isShow && (
                <th
                  colSpan={3}
                  className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300"
                >
                  Receiver Details
                </th>
              )}

              {columnsData.find((c) => c.value === "paymentDetails")
                ?.isShow && (
                <th
                  colSpan={2}
                  className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300"
                >
                  Payment Details
                </th>
              )}
              {!orderType && (
                <>
                  {columnsData.find((c) => c.value === "date")?.isShow && (
                    <th
                      colSpan={2}
                      className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300 "
                    >
                      Date
                    </th>
                  )}
                  {/* {columnsData.find((c) => c.value === "noOfAttempt")
                    ?.isShow && (
                    <th
                      colSpan={4}
                      className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300 "
                    >
                      No of Attempt
                    </th>
                  )} */}
                </>
              )}
              {!isOrder &&
                columnsData.find((c) => c.value === "itemDetail")?.isShow && (
                  <th
                    colSpan={2}
                    className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300"
                  >
                    Item Detail
                  </th>
                )}

              {columnsData.find((c) => c.value === "client")?.isShow && (
                <th
                  rowSpan={2}
                  className="px-4 pt-2 font-semibold text-[#131327]/70 border-x border-dashed border-gray-300"
                >
                  Merchant
                </th>
              )}

              {/* {columnsData.find((c) => c.value === "status")?.isShow && ( */}
              <th
                rowSpan={2}
                className="px-4 pt-2 font-semibold text-[#131327]/70 text-center border-x border-dashed border-gray-300"
              >
                Status
              </th>
              {/* )} */}
              {!pending && (
                <th
                  rowSpan={2}
                  className="px-4 pt-2 font-semibold text-center text-[#131327]/70"
                >
                  {" "}
                  Actions{" "}
                </th>
              )}
            </tr>
            <tr className="text-center">
              {columnsData.find((c) => c.value === "shippingDetails")
                ?.isShow && (
                <th
                  rowSpan={1}
                  className="px-4 font-normal text-[#131327]/70 border-t border-x border-l border-dashed border-gray-300 "
                >
                  Company
                </th>
              )}
              {columnsData.find((c) => c.value === "shippingDetails")
                ?.isShow && (
                <th
                  rowSpan={1}
                  className="px-4 font-normal text-[#131327]/70 border-t border-dashed border-gray-300 "
                >
                  AWB
                </th>
              )}
              {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}  
              <th className="px-4 font-normal text-[#131327]/70 border-l"></th>
              {/* )} */}
              {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
              <th className="px-4 font-normal text-[#131327]/70 border-t border-l border-x border-dashed border-gray-300 ">
                Country
              </th>
              {/* )} */}
              {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
              <th className="px-4 font-normal text-[#131327]/70 border-t border-x border-dashed border-gray-300">
                City
              </th>
              {/* )} */}
              {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
              <th className="px-4 font-normal text-[#131327]/70 border-t border-x border-dashed border-gray-300">
                District
              </th>
              {/* )} */}
              {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
              {/*
              <th className="px-4 font-normal text-[#131327]/70 border-t border-dashed border-gray-300">
                Street
              </th> */}
              <th className="px-4 font-normal text-[#131327]/70 border-t border-dashed border-gray-300">
                Short Address
              </th>
              {/* )} */}
              {columnsData.find((c) => c.value === "receiverDetails")
                ?.isShow && (
                <th className="px-4 font-normal text-[#131327]/70 border-t border-l border-x border-dashed border-gray-300">
                  Name
                </th>
              )}
              {columnsData.find((c) => c.value === "receiverDetails")
                ?.isShow && (
                <th className="px-4 font-normal text-[#131327]/70 border-t border-r border-x border-dashed border-gray-300">
                  Mobile
                </th>
              )}
              {columnsData.find((c) => c.value === "receiverDetails")
                ?.isShow && (
                <th className="px-4 font-normal text-[#131327]/70 border-t border-dashed border-gray-300">
                  Address
                </th>
              )}

              {columnsData.find((c) => c.value === "paymentDetails")
                ?.isShow && (
                <th className="px-4 text-center font-normal text-[#131327]/70 border-t border-l border-x border-dashed border-gray-300">
                  Mode
                </th>
              )}
              {columnsData.find((c) => c.value === "paymentDetails")
                ?.isShow && (
                <th className="px-4 text-center font-normal text-[#131327]/70 border-t border-r border-x border-dashed border-gray-300">
                  Amount
                </th>
              )}

              {!orderType && (
                <>
                  {columnsData.find((c) => c.value === "date")?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-x border-dashed border-gray-300">
                      Last Update
                    </th>
                  )}
                  {columnsData.find((c) => c.value === "date")?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-x border-dashed border-gray-300">
                      Dispatch
                    </th>
                  )}
                  {/* {columnsData.find((c) => c.value === "date")?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-r border-dashed border-gray-300">
                      Close
                    </th>
                  )} */}
                  {/* {columnsData.find((c) => c.value === "noOfAttempt")
                    ?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-r border-dashed border-gray-300">
                      Attempt
                    </th>
                  )} */}
                  {/* {columnsData.find((c) => c.value === "noOfAttempt")
                    ?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-r border-dashed border-gray-300">
                      FD1
                    </th>
                  )} */}
                  {/* {columnsData.find((c) => c.value === "noOfAttempt")
                    ?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-l border-dashed border-gray-300">
                      FD3
                    </th>
                  )} */}
                  {/* {columnsData.find((c) => c.value === "noOfAttempt")
                    ?.isShow && (
                    <th className="px-4 font-normal text-[#131327]/70 border-t border-x border-dashed border-gray-300">
                      FD4
                    </th>
                  )} */}
                </>
              )}
              {!isOrder &&
                columnsData.find((c) => c.value === "itemDetail")?.isShow && (
                  <th className="px-4 font-normal text-[#131327]/70 border-t border-r border-x border-dashed border-gray-300">
                    SKU
                  </th>
                )}

              {!isOrder &&
                columnsData.find((c) => c.value === "itemDetail")?.isShow && (
                  <th className="px-4 font-normal text-[#131327]/70 border-t border-r border-x border-dashed border-gray-300">
                    QTY.
                  </th>
                )}

              <th colSpan={5}></th>
            </tr>
          </thead>

          <tbody className="divide-y ">
            {data?.orders?.map((item: any, index: number) => (
              <tr className="hover:bg-[#FBD037]/20 group">
                {
                  // columnsData.find((c) => c.value === "checkbox")?.isShow &&
                  // isCheckboxEnabled && (
                  <td className="px-4 py-4 text-[#212121] ">
                    <label className="relative flex items-center cursor-pointer">
                      <input
                        type="checkbox"
                        checked={selectedOrders.some((o) => o.id === item.id)}
                        onChange={() => onSelectOrder(item)}
                        className="peer h-5 w-5 cursor-pointer appearance-none rounded border border-slate-300 checked:border-[#FBD037] 
                  bg-white checked:bg-[#FBD037] checked:text-white disabled:cursor-not-allowed"
                      />
                      <span
                        className="absolute text-xs font-bold text-white peer-checked:opacity-100 opacity-0 
                  top-1/2 left-[10px] transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
                      >
                        ✓
                      </span>
                    </label>
                  </td>
                  // )
                }
                {columnsData.find((c) => c.value === "sn")?.isShow && (
                  <td className="px-4 py-2 text-[#212121] ">
                    {(currentPage - 1) * limitPage + (index + 1)}
                  </td>
                )}
                {/* {columnsData.find((c) => c.value === "orderType")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  <div className="flex items-center space-x-4 text-sm font-medium w-full">
                    {item?.type === "outlet" ? (
                      <div className="flex items-center px-2 py-0.5 w-[68px] bg-[#5CC6CC] rounded-md">
                        <img
                          src="/img/dashboard-icons/lm-tag.svg"
                          className="w-6"
                          alt=""
                        />
                        <span>B2C</span>
                      </div>
                    ) : (
                      <div className="flex items-center px-2 py-0.5 w-[68px] bg-[#FDD535] rounded-md ">
                        <img src="/img/dashboard-icons/lm-tag.svg" alt="" />
                        <span>B2C</span>
                      </div>
                    )}
                  </div>
                </td>
                {/* )} */}

                {/* {columnsData.find((c) => c.value === "orderDate")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {formatDate(item?.createdAt)}
                </td>
                {/* )} */}
                {columnsData.find((c) => c.value === "platform")?.isShow && (
                  <td className="px-4 py-2 text-[#212121]">{item?.platform}</td>
                )}
                {/* {columnsData.find((c) => c.value === "awbNumber")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">{item?.awbNumber}</td>
                {/* )} */}
                {/* {columnsData.find((c) => c.value === "referenceNumber")
                  ?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {item?.referenceNumber}
                </td>
                {/* )} */}
                {/* {columnsData.find((c) => c.value === "routeCode")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">{item?.routeCode}</td>
                <td className="px-4 py-2 text-[#212121]">{item?.clientId}</td>
                {/* )} */}
                {columnsData.find((c) => c.value === "outletName")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121]">
                    {item?.clientName}
                  </td>
                )}
                {columnsData.find((c) => c.value === "shippingDetails")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121] text-center">
                    {item?.shippingCompany}
                  </td>
                )}
                {columnsData.find((c) => c.value === "shippingDetails")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121] text-center">
                    {item?.shippingAwbNumber}
                  </td>
                )}

                {/* {columnsData.find((c) => c.value === "origin")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {item?.senderCityName || item?.senderCityData}
                </td>
                {/* )} */}
                {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {item?.receiverCountryName || item?.receiverCountryData}
                </td>
                {/* )} */}
                {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {item?.receiverCityName || item?.receiverCityData}
                </td>
                {/* )} */}
                {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {item?.receiverDistrictName || item?.receiverDistrictData}
                </td>
                {/* )} */}
                {/* {columnsData.find((c) => c.value === "destination")?.isShow && ( */}
                <td className="px-4 py-2 text-[#212121]">
                  {item?.receiverNationalAddress || "--"}
                </td>
                {/* )} */}
                {columnsData.find((c) => c.value === "receiverDetails")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121]">
                    {item?.receiverName}
                  </td>
                )}

                {columnsData.find((c) => c.value === "receiverDetails")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121]">
                    {item?.receiverMobile}
                  </td>
                )}
                {columnsData.find((c) => c.value === "receiverDetails")
                  ?.isShow && (
                  <td
                    className="px-4 py-2 text-[#212121] max-w-[150px] truncate"
                    title={item?.receiverAddress?.replace(/<[^>]*>/g, "")}
                  >
                    {item?.receiverAddress?.replace(/<[^>]*>/g, "")}
                  </td>
                )}
                {columnsData.find((c) => c.value === "paymentDetails")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121] text-center">
                    {item?.paymentType}
                  </td>
                )}
                {columnsData.find((c) => c.value === "paymentDetails")
                  ?.isShow && (
                  <td className="px-4 py-2 text-[#212121] text-center">
                    {item?.codAmount || 0}
                  </td>
                )}

                {!orderType && (
                  <>
                    {columnsData.find((c) => c.value === "date")?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {formatDate(item?.updatedAt)}
                      </td>
                    )}
                    {columnsData.find((c) => c.value === "date")?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {item?.drsCreatedAt
                          ? formatDate(item?.drsCreatedAt)
                          : ""}
                      </td>
                    )}
                    {/* {columnsData.find((c) => c.value === "date")?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {item?.closeDate}
                      </td>
                    )} */}
                    {/* {columnsData.find((c) => c.value === "noOfAttempt")
                      ?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {item?.deliveryAttempt}
                      </td>
                    )} */}
                    {/* {columnsData.find((c) => c.value === "noOfAttempt")
                      ?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {item?.deliveryAttempt1}
                      </td>
                    )} */}
                    {/* {columnsData.find((c) => c.value === "noOfAttempt")
                      ?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {item?.deliveryAttempt2}
                      </td>
                    )} */}
                    {/* {columnsData.find((c) => c.value === "noOfAttempt")
                      ?.isShow && (
                      <td className="px-4 py-2 text-[#212121]">
                        {item?.deliveryAttempt3}
                      </td>
                    )} */}
                  </>
                )}

                { !isOrder &&  columnsData.find((c) => c.value === "itemDetail")?.isShow && (
                  <>
                    <td className="px-4 py-2 text-[#212121]">
                      {item.olineItems && Array.isArray(item?.olineItems)
                        ? item.olineItems.map((i: any) => (
                            <span
                              key={i.sku}
                              title={i.sku}
                              className="inline-block mr-1"
                            >
                              {i.sku.slice(0, 7)}....
                            </span>
                          ))
                        : ""}
                    </td>
                    <td className="px-4 py-2 text-[#212121]">
                      {item.olineItems && Array.isArray(item?.olineItems)
                        ? item.olineItems.map((i: any) => i.quantity).join(", ")
                        : ""}
                    </td>
                  </>
                )}

                {columnsData.find((c) => c.value === "client")?.isShow && (
                  <td className="px-4 py-2 text-[#212121]">
                    {item?.clientName}
                  </td>
                )}

                {/* {columnsData.find((c) => c.value === "status")?.isShow && ( */}
                <td className="px-4 pt-4 py-5 whitespace-nowrap text-[#212121] text-center">
                  <span
                    className={`px-3 py-1.5 rounded-full text-xs font-medium ${getStatusClass(
                      item?.status
                    )}`}
                  >
                    {item?.subStatus && item?.subStatus === "reverseOrder"
                      ? `Rev/`
                      : ""}
                    {formatStatus(item?.status)}
                  </span>
                </td>
                {/* )} */}

                <td className="px-4 py-2 text-[#212121]  relative text-center">
                  <button
                    onClick={() => navigate(`/orders/${item?.id}`)}
                    className="p-2 border rounded-full bg-[#F7F6F2]"
                  >
                    <IconEye size={22} />
                  </button>
                  {/* <a
                    href={`/orders/${item?.awbNumber}`}
                    rel="noopener noreferrer"
                    className="inline-flex items-center justify-center p-2 border rounded-full bg-[#F7F6F2] hover:bg-[#e8e7e3] transition-colors"
                  >
                    <IconEye size={22} />
                  </a> */}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AllOrderTable;
